import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Shield, Trash2 } from "lucide-react";

export default function DeleteAccountPage() {
  const emailSubject = encodeURIComponent("Solicitud de eliminación de cuenta SUCO");
  const emailBody = encodeURIComponent(
    "Hola equipo SUCO,\n\n" +
    "Solicito la eliminación de mi cuenta y todos los datos asociados.\n\n" +
    "Datos de mi cuenta:\n" +
    "- Nombre del negocio: \n" +
    "- Email registrado: \n" +
    "- Motivo (opcional): \n\n" +
    "Confirmo que soy el titular de esta cuenta.\n\n" +
    "Gracias."
  );

  return (
    <div className="legal-page" data-testid="delete-account-page">
      <header className="legal-header">
        <Link to="/" className="legal-back" data-testid="delete-back-link">
          <ArrowLeft size={18} />
          Volver
        </Link>
        <h1>Eliminar mi cuenta y datos</h1>
        <p className="legal-updated">SUCO — Sistema de Quejas y Sugerencias</p>
      </header>

      <main className="legal-content">
        <section>
          <p>
            En SUCO respetamos tu derecho a la privacidad y tu control sobre tus datos personales.
            Puedes solicitar la eliminación de tu cuenta y toda la información asociada en cualquier momento.
          </p>
        </section>

        <section>
          <h2><Trash2 size={18} style={{ verticalAlign: "middle" }} /> Cómo solicitar la eliminación</h2>
          <p>
            Envía un correo electrónico desde el email registrado en tu cuenta a:
          </p>
          <p style={{ textAlign: "center", margin: "18px 0" }}>
            <a
              href={`mailto:info@sucomx.com?subject=${emailSubject}&body=${emailBody}`}
              style={{
                display: "inline-block",
                background: "#DC2626",
                color: "white",
                padding: "12px 24px",
                borderRadius: 8,
                textDecoration: "none",
                fontWeight: 600,
              }}
              data-testid="delete-request-email-btn"
            >
              <Mail size={16} style={{ verticalAlign: "middle", marginRight: 8 }} />
              Solicitar eliminación por email
            </a>
          </p>
          <p style={{ fontSize: "0.9rem", color: "#64748B" }}>
            O escribe directamente a <a href="mailto:info@sucomx.com">info@sucomx.com</a>
            {" "}con el asunto "Solicitud de eliminación de cuenta".
          </p>
        </section>

        <section>
          <h2><Shield size={18} style={{ verticalAlign: "middle" }} /> Qué datos se eliminan</h2>
          <p>Al procesar tu solicitud, eliminaremos de forma permanente:</p>
          <ul>
            <li>Tu perfil de negocio (nombre, correo, teléfono, logotipo).</li>
            <li>Todas las quejas y sugerencias recibidas en tu cuenta.</li>
            <li>Tus sucursales (si aplica).</li>
            <li>Configuraciones de WiFi guardadas.</li>
            <li>Códigos QR y carteles generados.</li>
            <li>Historial de accesos.</li>
          </ul>
        </section>

        <section>
          <h2>⏳ Tiempo de procesamiento</h2>
          <p>
            Confirmaremos la recepción de tu solicitud en un plazo máximo de <strong>72 horas</strong>.
            La eliminación completa se realizará en un plazo máximo de <strong>30 días</strong>,
            conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (México).
          </p>
        </section>

        <section>
          <h2>📌 Datos que retenemos por obligación legal</h2>
          <p>
            Por motivos contables y fiscales, mantenemos durante <strong>hasta 90 días</strong> después de la eliminación:
          </p>
          <ul>
            <li>Comprobantes de pago procesados por Stripe/PayPal (solo identificadores de transacción, nunca información de tarjetas).</li>
            <li>Registros de facturación exigidos por el SAT.</li>
          </ul>
          <p style={{ fontSize: "0.9rem", color: "#64748B" }}>
            Esta información se elimina automáticamente después del plazo mencionado.
          </p>
        </section>

        <section>
          <h2>⚠️ Antes de eliminar tu cuenta</h2>
          <ul>
            <li>Si tienes suscripción activa, cancélala primero desde tu panel para evitar cobros futuros.</li>
            <li>Descarga tus reportes de quejas y sugerencias si los necesitas para tu historial.</li>
            <li>La eliminación es <strong>irreversible</strong>: no podremos recuperar tus datos después.</li>
          </ul>
        </section>

        <section>
          <h2>📞 Contacto</h2>
          <p>
            Si tienes preguntas sobre este proceso, escríbenos a{" "}
            <a href="mailto:info@sucomx.com">info@sucomx.com</a> o consulta nuestra{" "}
            <Link to="/privacy">Política de Privacidad</Link>.
          </p>
        </section>
      </main>

      <footer className="legal-footer">
        <p>© {new Date().getFullYear()} SUCO — sucomx.com</p>
      </footer>
    </div>
  );
}
